import {
  isOutputNode,
  isRootNode,
} from 'processes/graph-builder-processes/flowchart-viz/util/getNodeDetailsTypeForInteractiveNode';
import {
  ProcessTaskSchemaForGraphBuilderValidation,
  ProcessGraphBuilderNodeType,
} from 'processes/graph-builder-processes/validation/ProcessGraphBuilderConstants';

import {ProcessFlowchartInteractiveNode} from '../ProcessFlowchartVizConstants';

export function getGraphBuilderNodeType(
  node: ProcessFlowchartInteractiveNode,
  flowchartSchema: ProcessTaskSchemaForGraphBuilderValidation
): ProcessGraphBuilderNodeType {
  if (isOutputNode(node)) {
    return ProcessGraphBuilderNodeType.FLOWCHART_OUTPUT;
  } else if (isRootNode(node)) {
    return ProcessGraphBuilderNodeType.FLOWCHART_TASK;
  }
  return ProcessGraphBuilderNodeType.FLOWCHART_STEP;
}
